'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useRef, useEffect, useCallback } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useSession, signOut } from 'next-auth/react';
import { MegaMenu } from './MegaMenu';
import { MobileNav } from './MobileNav';
import { SearchBar } from '@/components/search/SearchBar';
import { useCart } from '@/contexts/CartContext';
import { MiniCart } from '@/components/cart/MiniCart';
import type { MenuCategory } from '@/services/category.service';
import { HUBSPOT_EMBEDS_DISABLED } from '@/lib/hubspot-embed-gate';
interface HeaderProps {
  menuCategories: MenuCategory[];
}
export function Header(t0) {
  const $ = _c(61);
  const {
    menuCategories
  } = t0;
  const {
    itemCount,
    isAddingToCart
  } = useCart();
  const {
    data: session,
    status
  } = useSession();
  const isAuthenticated = !!session?.user;
  const [accountDropdownOpen, setAccountDropdownOpen] = useState(false);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const [miniCartOpen, setMiniCartOpen] = useState(false);
  const dropdownRef = useRef(null);
  const miniCartRef = useRef(null);
  const miniCartTimerRef = useRef(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const handleClickOutside = function handleClickOutside(event) {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
          setAccountDropdownOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const handleClickOutside_0 = function handleClickOutside(event_0) {
        if (miniCartRef.current && !miniCartRef.current.contains(event_0.target as Node)) {
          setMiniCartOpen(false);
        }
      };
      const handleEscape = function handleEscape(event_1) {
        if (event_1.key === "Escape") {
          setMiniCartOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside_0);
      document.addEventListener("keydown", handleEscape);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside_0);
        document.removeEventListener("keydown", handleEscape);
      };
    };
    t4 = [];
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  useEffect(t3, t4);
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      if (miniCartTimerRef.current) {
        clearTimeout(miniCartTimerRef.current);
        miniCartTimerRef.current = null;
      }
      setMiniCartOpen(true);
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const handleMiniCartEnter = t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      miniCartTimerRef.current = setTimeout(() => {
        setMiniCartOpen(false);
      }, 300);
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const handleMiniCartLeave = t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = HUBSPOT_EMBEDS_DISABLED ? <div className="hidden md:flex items-center text-[#333333] font-semibold" data-hubspot-embed-disabled="true" title="HubSpot CTA disabled on staging"><span style={{
        fontSize: "16px"
      }}>On-Demand Demo</span></div> : <div className="hidden md:flex items-center text-[#333333] hover:text-[#000000] font-semibold transition-colors" dangerouslySetInnerHTML={{
      __html: "<div class=\"hs-web-interactive-inline\" data-hubspot-wrapper-cta-id=\"186126081177\"><span class=\"hs-cta-wrapper hs-web-interactive-wrapper\"><span class=\"hs-cta-node hs-web-interactive-node\"><a href=\"https://cta-service-cms2.hubspot.com/web-interactives/public/v1/track/click?encryptedPayload=AVxigLK5UAar0IhkqBmLwRJ106Sa7qS3UX6yn%2BR7h%2FBl9B%2BrWp%2B%2BlBwQ0ZgO9nmHvbVc9kfGRu33%2F59%2B%2Bc%2BPCZndNc3Yb4nurqfnfS3Mi0BVl07y0%2B5LFpQMA5pM%2BS5IfzY33JiBoLI7R60cjJntY93fIX7JRzMP37cDsLmOhZ6q30gszzQzcFcszn%2BW%2FA%3D%3D&amp;portalId=5417380\" class=\"hs-inline-web-interactive-186126081177\" data-hubspot-cta-id=\"186126081177\"><span style=\"font-size:16px;\">On-Demand Demo</span></a></span></span></div>"
    }} />;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <a href="tel:828-483-4237" className="flex items-center gap-1 hover:text-black transition-colors"><PhoneIcon className="header-phone-icon h-3 w-3 text-[#ED8326]" /><span>Sales: 828-483-4237</span></a>;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="bg-[#e2e2e2] text-[#333333]"><div className="header-container header-topbar flex h-[28px] items-center justify-between text-xs">{t7}<div className="header-top-links flex items-center gap-4">{t8}<a href="tel:828-352-2242" className="flex items-center gap-1 hover:text-black transition-colors"><PhoneIcon className="header-phone-icon h-3 w-3 text-[#ED8326]" /><span>Support: 828-352-2242</span></a>{HUBSPOT_EMBEDS_DISABLED ? <div className="flex items-center" data-hubspot-embed-disabled="true" title="HubSpot CTA disabled on staging"><span style={{
              fontSize: "16px"
            }}><svg className="header-quote-icon" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z" /></svg>Get A Quote</span></div> : <div className="flex items-center hover:text-black transition-colors" dangerouslySetInnerHTML={{
            __html: "<div class=\"hs-web-interactive-inline\" data-hubspot-wrapper-cta-id=\"171381198998\"><span class=\"hs-cta-wrapper hs-web-interactive-wrapper\"><span class=\"hs-cta-node hs-web-interactive-node\"><a href=\"https://cta-service-cms2.hubspot.com/web-interactives/public/v1/track/click?encryptedPayload=AVxigLKwqUx%2BZH%2FGL5RgvvYu89qmQuzXKgZUhx8%2BnY6mIRDooHfVFqhN2pxOzIN7yx7nbZB%2F%2F3exyWzZ5Vewc7%2F6dtDWswYF8pL6GJbBpicwSKz%2FEx4Tkuj0cFmkgRtJHpNgJEuHWla0DgVhxWTsPQ06pUTgrma5AKiVIPYwAdBWJrMQAonFYvc%3D&amp;portalId=5417380\" class=\"hs-inline-web-interactive-171381198998\" data-hubspot-cta-id=\"171381198998\"><span style=\"font-size:16px;\"><svg class=\"header-quote-icon\" aria-hidden=\"true\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z\"></path></svg>Get A Quote</span></a></span></span></div>"
          }} />}</div></div></div>;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== menuCategories) {
    t10 = <MobileNav categories={menuCategories} />;
    $[9] = menuCategories;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Link href="/" className="flex items-center shrink-0"><Image src="https://scw-commerce-media.s3.amazonaws.com/pub/media/logo/stores/1/logo-scw.jpeg" alt="SCW Security Camera Warehouse" width={200} height={39} className="block" style={{
        width: "154px",
        height: "auto"
      }} priority={true} /></Link>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== menuCategories) {
    t12 = <div className="hidden lg:block flex-1 min-w-0"><MegaMenu categories={menuCategories} /></div>;
    $[12] = menuCategories;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="hidden md:flex items-center"><SearchBar /></div>;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== mobileSearchOpen) {
    t14 = () => setMobileSearchOpen(!mobileSearchOpen);
    $[15] = mobileSearchOpen;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  const t15 = `md:hidden flex h-8 w-8 items-center justify-center transition-colors ${mobileSearchOpen ? "text-[#ED8326]" : "text-gray-600 hover:text-[#ED8326]"}`;
  let t16;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <SearchIcon className="h-5 w-5" />;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  let t17;
  if ($[18] !== mobileSearchOpen || $[19] !== t14 || $[20] !== t15) {
    t17 = <button type="button" onClick={t14} className={t15} aria-label="Search" aria-expanded={mobileSearchOpen}>{t16}</button>;
    $[18] = mobileSearchOpen;
    $[19] = t14;
    $[20] = t15;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] !== accountDropdownOpen) {
    t18 = () => setAccountDropdownOpen(!accountDropdownOpen);
    $[22] = accountDropdownOpen;
    $[23] = t18;
  } else {
    t18 = $[23];
  }
  let t19;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <UserIcon className="h-5 w-5" />;
    $[24] = t19;
  } else {
    t19 = $[24];
  }
  let t20;
  if ($[25] !== accountDropdownOpen || $[26] !== t18) {
    t20 = <button type="button" onClick={t18} className="flex h-8 w-8 items-center justify-center text-gray-600 hover:text-[#ED8326] transition-colors" aria-label="Account" aria-expanded={accountDropdownOpen}>{t19}</button>;
    $[25] = accountDropdownOpen;
    $[26] = t18;
    $[27] = t20;
  } else {
    t20 = $[27];
  }
  let t21;
  if ($[28] !== accountDropdownOpen || $[29] !== isAuthenticated || $[30] !== status) {
    t21 = accountDropdownOpen && <div className="absolute right-0 top-full mt-2 w-56 bg-white border border-gray-200 rounded-md shadow-lg z-50"><div className="flex justify-end p-2 border-b"><button onClick={() => setAccountDropdownOpen(false)} className="text-xs text-gray-500 hover:text-gray-700 uppercase tracking-wide">Close X</button></div>{status === "loading" ? <div className="p-4 text-center text-gray-500">Loading...</div> : isAuthenticated ? <div className="py-2"><Link href="/account" className="block px-4 py-3 text-center text-sm font-medium text-gray-700 hover:bg-gray-50 border-b" onClick={() => setAccountDropdownOpen(false)}>MY ACCOUNT</Link><button onClick={() => {
          setAccountDropdownOpen(false);
          localStorage.removeItem("cart_session_id");
          signOut({
            callbackUrl: "/"
          });
        }} className="block w-full px-4 py-3 text-center text-sm font-medium text-gray-700 hover:bg-gray-50">SIGN OUT</button></div> : <div className="py-2"><Link href="/register" className="block px-4 py-3 text-center text-sm font-medium text-gray-700 hover:bg-gray-50 border-b" onClick={() => setAccountDropdownOpen(false)}>CREATE ACCOUNT</Link><Link href="/login" className="block px-4 py-3 text-center text-sm font-medium text-gray-700 hover:bg-gray-50" onClick={() => setAccountDropdownOpen(false)}>LOG IN</Link></div>}</div>;
    $[28] = accountDropdownOpen;
    $[29] = isAuthenticated;
    $[30] = status;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] !== t20 || $[33] !== t21) {
    t22 = <div className="relative" ref={dropdownRef}>{t20}{t21}</div>;
    $[32] = t20;
    $[33] = t21;
    $[34] = t22;
  } else {
    t22 = $[34];
  }
  let t23;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <CartIcon className="h-5 w-5" />;
    $[35] = t23;
  } else {
    t23 = $[35];
  }
  let t24;
  if ($[36] !== isAddingToCart) {
    t24 = isAddingToCart && <span className="cart-icon-spinner" />;
    $[36] = isAddingToCart;
    $[37] = t24;
  } else {
    t24 = $[37];
  }
  let t25;
  if ($[38] !== itemCount) {
    t25 = itemCount > 0 && <span className="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-[#ED8326] text-[10px] font-medium text-white">{itemCount > 99 ? "99+" : itemCount}</span>;
    $[38] = itemCount;
    $[39] = t25;
  } else {
    t25 = $[39];
  }
  let t26;
  if ($[40] !== t24 || $[41] !== t25) {
    t26 = <Link href="/checkout/cart" className="relative flex h-8 w-8 items-center justify-center text-gray-600 hover:text-[#ED8326] transition-colors" aria-label="Cart">{t23}{t24}{t25}</Link>;
    $[40] = t24;
    $[41] = t25;
    $[42] = t26;
  } else {
    t26 = $[42];
  }
  let t27;
  if ($[43] !== miniCartOpen) {
    t27 = miniCartOpen && <MiniCart />;
    $[43] = miniCartOpen;
    $[44] = t27;
  } else {
    t27 = $[44];
  }
  let t28;
  if ($[45] !== t26 || $[46] !== t27) {
    t28 = <div ref={miniCartRef} className="mini-cart-wrapper" onMouseEnter={handleMiniCartEnter} onMouseLeave={handleMiniCartLeave}>{t26}{t27}</div>;
    $[45] = t26;
    $[46] = t27;
    $[47] = t28;
  } else {
    t28 = $[47];
  }
  let t29;
  if ($[48] !== t17 || $[49] !== t22 || $[50] !== t28) {
    t29 = <div className="ml-auto flex items-center gap-3">{t13}{t17}{t22}{t28}</div>;
    $[48] = t17;
    $[49] = t22;
    $[50] = t28;
    $[51] = t29;
  } else {
    t29 = $[51];
  }
  let t30;
  if ($[52] !== t10 || $[53] !== t12 || $[54] !== t29) {
    t30 = <div className="header-container flex h-[60px] items-center gap-4">{t10}{t11}{t12}{t29}</div>;
    $[52] = t10;
    $[53] = t12;
    $[54] = t29;
    $[55] = t30;
  } else {
    t30 = $[55];
  }
  let t31;
  if ($[56] !== mobileSearchOpen) {
    t31 = mobileSearchOpen && <div className="md:hidden bg-[#f5f5f5] border-t border-gray-200 px-4 pt-2 pb-6"><div className="flex justify-end mb-1"><button type="button" onClick={() => setMobileSearchOpen(false)} className="py-2 text-sm font-bold uppercase tracking-wide text-[#ED8326]">Close X</button></div><SearchBar variant="page" autoFocus={true} onNavigate={() => setMobileSearchOpen(false)} /></div>;
    $[56] = mobileSearchOpen;
    $[57] = t31;
  } else {
    t31 = $[57];
  }
  let t32;
  if ($[58] !== t30 || $[59] !== t31) {
    t32 = <header className="site-header sticky top-0 z-50 w-full">{t9}<div className="bg-white border-b shadow-sm">{t30}{t31}</div></header>;
    $[58] = t30;
    $[59] = t31;
    $[60] = t32;
  } else {
    t32 = $[60];
  }
  return t32;
}
function SearchIcon(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <circle cx="11" cy="11" r="8" />;
    t2 = <path d="m21 21-4.35-4.35" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>{t1}{t2}</svg>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function CartIcon(t0) {
  const $ = _c(5);
  const {
    className
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <circle cx="8" cy="21" r="1" />;
    t2 = <circle cx="19" cy="21" r="1" />;
    t3 = <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== className) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>{t1}{t2}{t3}</svg>;
    $[3] = className;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
function UserIcon(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />;
    t2 = <circle cx="12" cy="7" r="4" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>{t1}{t2}</svg>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function PhoneIcon(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}